<template>
  <div class="footer desktop-only">
    <div class="copyright">© 2016 Banca Profilo S.p.A | P.IVA 09108700155</div>
    <div class="links">
      <a
        target="_blank"
        href="https://www.bancaprofilo.it/interna.php?numpag=137"
        >Privacy</a
      >
      <a
        target="_blank"
        href="https://www.bancaprofilo.it/interna.php?numpag=100"
        >Cookie policy</a
      >
      <a
        target="_blank"
        href="https://www.bancaprofilo.it/interna.php?numpag=53"
        >Trasparenza</a
      >
      <a
        target="_blank"
        href="https://www.bancaprofilo.it/interna.php?numpag=54"
        >Disclaimer</a
      >
      <a
        target="_blank"
        href="https://www.bancaprofilo.it/interna.php?numpag=57"
        >Note Legali</a
      >
    </div>
    <div class="support js-open-help" @click="openSupport">Supporto online</div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  //TODO: remove this
  data() {
    return {
      username: ""
    };
  },
  methods: {
    openSupport() {
      this.$root.$emit("openHelp");
    }
  },
  mounted() {}
};
</script>

<style scoped lang="less">
.footer {
  height: 80px;
  background: #eaeaea;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  font-size: 11px;
  .support {
    background: #CC4B00;
    color: white;
    padding: 3px 15px;
    border-radius: 10px;
    cursor: pointer;
  }
  .links a {
    font-weight: bold;
    margin: 0 5px;
  }
}
</style>
